import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestApiService } from '../rest-api.service';
import { IDeleteDocumentInputModel, DrawingInactiveInputModel } from 'src/app/ViewModel/DeletedocumentModel';

@Injectable({
  providedIn: 'root'
})
export class DeleteDocumentService {
  private _urlDeleteDocumentList = 'RepositoryDocuments/DeleteDocumentList';
  private _urlGetDeleteDocumentlist = 'RepositoryDocuments/GetDeleteDocumentlist';
  private _urlUpdateDrawingDocumentStatus = 'RepositoryDocuments/UpdateDrawingDocumentStatus';
  private _urlGetDrawingInactiveDocumentlist = 'RepositoryDocuments/GetDrawingInactiveDocumentlist';
 

  constructor(private restAPIService: RestApiService) { }


  /**
   
   * @param DocSLNo
   */
  public DeleteDocumentList(docInputModel: IDeleteDocumentInputModel): Observable<any> {
    return this.restAPIService.new_POST(this._urlDeleteDocumentList, docInputModel);
  }

  public GetDeleteDocumentlist(docInputModel: IDeleteDocumentInputModel): Observable<any> {
    return this.restAPIService.new_POST(this._urlGetDeleteDocumentlist, docInputModel);
  }
  public UpdateDrawingStatus(docInputModel: DrawingInactiveInputModel): Observable<any> {
    return this.restAPIService.new_POST(this._urlUpdateDrawingDocumentStatus, docInputModel);
  }

  public GetDrawingInactiveDocumentlist(docInputModel: DrawingInactiveInputModel): Observable<any> {
    return this.restAPIService.new_POST(this._urlGetDrawingInactiveDocumentlist, docInputModel);
  }


}
